export const AUDIT_CONSTS = {
  moduleName: 'epb-audit',

  getters: {
    data: 'data'
  },
  actions: {
    list: 'list'
  },
  mutations: {
    setData: 'setData'
  }

};
